import React from 'react';
import { isRichTextMeaningful } from '../../utils/richText';

interface RichTextContentProps {
  content?: string | null;
  className?: string;
  fallback?: React.ReactNode;
}

const RichTextContent: React.FC<RichTextContentProps> = ({
  content,
  className = '',
  fallback = <span className="italic text-neutral-text-secondary">Tidak ada</span>,
}) => {
  if (!isRichTextMeaningful(content)) {
    return <>{fallback}</>;
  }

  return (
    <div
      className={`rich-text-content ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: content || '' }}
    />
  );
};

export default RichTextContent;
